import {Button, IconClose, IconHelp, IconLogout, IconMenu, IconTalkChat} from '@sportcast/ui-react';
import {useState} from 'react';
import {Collapse} from 'react-bootstrap';
import {useTranslation} from 'react-i18next';
import {useNavigate} from 'react-router-dom';
import {NavigationItem, useNavigationContext} from './NavigationContext';

function MobileHeader() {
    const [t] = useTranslation();
    const navigate = useNavigate();
    const [menuOpen, setMenuOpen] = useState<boolean>(false);
    const {
        navigationItems,
        bottomNavigationItems,
        goHome,
        logout
    } = useNavigationContext();

    const allItems = navigationItems.concat(bottomNavigationItems);
    let title = '';
    allItems.forEach((navigationItem: NavigationItem) => {
        if (navigationItem.selected) {
            title = navigationItem.title;
        }
    });

    function navigateToPath(path: string) {
        navigate(path);
    }

    return (
        <>
            <div className="header-content-without-sidebar">
                <div className="row justify-content-between g-0">
                    <div className="col-auto">
                        <div className="logo" onClick={goHome} title={t('navigation.HOME')}>
                        </div>
                    </div>
                    <div className="col-auto m-auto text-center navigation-title">
                        {title}
                    </div>
                    <div className="col-auto mt-1 me-2">
                        <span data-tooltip-id="header-tooltip"
                              data-tooltip-content={t('header.MENU')}>
                            <Button variant="transparent" icon={menuOpen ? IconClose : IconMenu}
                                    onClick={() => setMenuOpen(!menuOpen)}/>
                        </span>
                    </div>
                </div>
            </div>
            <Collapse in={menuOpen}>
                <div className="menu-sheet">
                    {
                        navigationItems.map((navigationItem: NavigationItem) => (
                            <div className={`row burger-item g-0 ${navigationItem.selected ? 'selected-burger' : ''}`}
                                 key={`navigation-item-${navigationItem.title}`}
                                 onClick={() => {
                                     setMenuOpen(false);
                                     navigateToPath(navigationItem.href);
                                 }}>
                                <div className="col-auto">
                                    <div className="navigation-icon">
                                        {navigationItem.icon}
                                    </div>
                                </div>
                                <div className="col">
                                    <div className="burger-title">
                                        {navigationItem.title}
                                    </div>
                                </div>
                            </div>
                        ))
                    }
                    {
                        bottomNavigationItems.map((navigationItem: NavigationItem) => (
                            <div className={`row burger-item g-0 ${navigationItem.selected ? 'selected-burger' : ''}`}
                                 key={`navigation-item-${navigationItem.title}`}
                                 title={navigationItem.title}
                                 onClick={() => {
                                     setMenuOpen(false);
                                     navigateToPath(navigationItem.href);
                                 }}>
                                <div className="col-auto">
                                    <div className="navigation-icon">
                                        {navigationItem.icon}
                                    </div>
                                </div>
                                <div className="col">
                                    <div className="burger-title">
                                        {navigationItem.title}
                                    </div>
                                </div>
                            </div>
                        ))
                    }
                    <div className="row justify-content-center logout-button">
                        <Button variant="outline"
                                icon={IconLogout}
                                label={t('header.LOGOUT')}
                                onClick={logout}
                        />
                    </div>
                    <div className="mt-3">
                        <span data-tooltip-content={t('header.HELP')}
                              data-tooltip-id="header-tooltip">
                            <Button
                                variant="transparentSm"
                                icon={IconHelp}
                                label={t('header.HELP')}
                                onClick={() => navigate('/help')}
                            />
                        </span>
                    </div>
                    <div>
                        <span data-tooltip-id="header-tooltip"
                              data-tooltip-content={t('header.CONTACT')}>
                            <Button
                                variant="transparentSm"
                                icon={IconTalkChat}
                                label={t('header.CONTACT')}
                                onClick={() => navigate('/contact')}
                            />
                        </span>
                    </div>
                </div>
            </Collapse>
        </>
    );
}

export default MobileHeader;
